import React from "react";
import IComponentSelect from "react-common-components/dist/components/Select/interface";
import Select from "src/components/Select";
import { useTranslation } from "src/context/Translations/context";
import { MeetingGroupers } from "src/pages/Meetings/Panel/interface";

const LovGrouperMeeting: React.FC<Omit<IComponentSelect, "options">> = ({
	name,
	label,
	control,
	...rest
}) => {
	const {translate} = useTranslation();
	return (<Select 
		name={name}
		control={control}
		label={label ?? translate("Agrupadores")}
		options={[
			{ value: MeetingGroupers.MEETING_TYPE, label: `${translate("Tipo de reunião")}` },
			{ value: MeetingGroupers.RESPONSIBLE, label: `${translate("Responsável")}` },
			{ value: MeetingGroupers.MEETING_ROOM, label: `${translate("Sala de reunião")}` },
			{ value: MeetingGroupers.PARTICIPANT, label: `${translate("Participantes")}` },	
			{ value: MeetingGroupers.MAP, label: `${translate("Mapa")}` }	
		]}
		{...rest}
	/>);
};

export default LovGrouperMeeting;
